export default "__VITE_ASSET__CtdruQob__"